<template>

	<div class="panel panel-clinic">

		<div class="panel-heading collapsed" href="#form_mp" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Massörsportal - lösenord och inloggningar</h2>

		</div>

		<div id="form_mp" class="panel-collapse collapse">

			<div class="panel-body">

				<h3>Återställ lösenord</h3>
				<div class="clinic-outer-form-group">
					Klicka på knappen för att skicka återställningslänk till massörens e-postadress <b>{{ clinic.email }}</b><br>
					<button v-on:click="submitResetPassword()" class="btn btn-sm btn-default" style="margin-top:10px;">Återställ lösenord</button>
				</div>

                <h3>Inaktivera inloggning</h3>
                <div class="clinic-outer-form-group">
                    Klicka på knappen för att inaktivera inloggning för massören<br>
                    <button v-on:click="submitDisable()" class="btn btn-sm" :class="{ 'btn-danger': !clinic.disabled_at, 'btn-default': clinic.disabled_at }" style="margin-top:10px;">
                        {{ disableButtonText }}
                    </button>
                </div>

				<h3>Inloggningar</h3>
				<p style="margin-top:-10px; margin-bottom:20px;">
					<b>Totalt:</b> {{ totalLogins }} st<br>
					<b>Denna månaden:</b> {{ monthlyLogins }} st
				</p>

				<div class="list-group" style="max-height:300px; overflow:auto" >
					<div class="list-group-item" v-for="entry in loginLog">
						<div class="row">
							<div class="col-md-10 col-xs-30">{{ entry.created_at }}</div>
							<div class="col-md-10 col-xs-20">Inloggning</div>
						</div>
					</div>
				</div>

			</div>

		</div>

	</div>

</template>


<script>

	import mixin from './mixin'

    export default {

    	mixins: [mixin],

    	props: {

    		loginLog: {
    			required: true
    		}

    	},

	    data() {

      		return {

      			email: this.clinic.email,

      		}

	    },

        computed: {

            totalLogins()
            {
                return this.loginLog.length
            },

            monthlyLogins ()
            {
                let logins = 0
                _.forEach(this.loginLog, (login) => {
                    if(moment(login.created_at).isBetween(moment().startOf('month'), moment().endOf('month'))) {
                        logins++
                    }
                })
                return logins
            },

            disableButtonText ()
            {
                return this.clinic.disabled_at ? 'Aktivera inloggning' : 'Inaktivera inloggning'
            }
        },

	    methods: {

	    	submitResetPassword ()
            {
	    		this.$http.post('/clinics/resetPassword', {
                    clinic_id: this.clinic.id,
                    email: this.clinic.email
                }).then((response) => {
                   bus.$emit('notify', 'Mail till massör är skickat.')
                }, (response) => {
                    console.log(JSON.stringify(response));
                })
	    	},

            submitDisable ()
            {
                this.clinic.disabled_at = this.clinic.disabled_at ? null : moment().format('YYYY-MM-DD')

                bus.$emit('notify', (this.clinic.disabled_at ? 'Massörens inloggning är nu inaktiverad' : 'Massörens inloggning är nu aktiverad'))
            }

	    }

	}

</script>
